import { Component } from '@angular/core';

@Component({
  selector: 'app-notfound',
  standalone: false,
  styleUrls: ['./../error.scss'],
  template: `<div class="container-fluid">
  <div class="row">
      <div class="col">
          <div class="no-data">
            <div>
              <h1>Page not found</h1>
              <span>Oops! Sorry, we can't find the page you're looking for.</span>
              <a class="btn-brand primary d-inline-block mt-2" [routerLink]="['/']">Back to Home</a>
            </div>
          </div>
      </div>
  </div>
</div>`
})
export class NotFoundComponent {
}
